import { createActions, createReducer } from 'reduxsauce'

import DetalhesOrdensPagamentosExtraorcamentariasService from '../../servicos/DetalhesOrdensPagamentosExtraorcamentariasService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaDetalhesOrdensPagamentosExtraorcamentariasInicio: [],
    buscaDetalhesOrdensPagamentosExtraorcamentariasSucesso: ['detalhesOrdensPagamentosExtraorcamentarias'],
    buscaDetalhesOrdensPagamentosExtraorcamentariasErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaDetalhesOrdensPagamentosExtraorcamentarias = filtro => {
    return dispatch => {
        dispatch(Creators.buscaDetalhesOrdensPagamentosExtraorcamentariasInicio())
        let serv = new DetalhesOrdensPagamentosExtraorcamentariasService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaDetalhesOrdensPagamentosExtraorcamentariasSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaDetalhesOrdensPagamentosExtraorcamentariasErro(error)))
    }
}

const buscaDetalhesOrdensPagamentosExtraorcamentariasInicio = (state = INITIAL_STATE, action) => {
    return { ...state, carregando: true, erro: null }
}

const buscaDetalhesOrdensPagamentosExtraorcamentariasErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaDetalhesOrdensPagamentosExtraorcamentariasSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.detalhesOrdensPagamentosExtraorcamentarias[0], carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_DETALHES_ORDENS_PAGAMENTOS_EXTRAORCAMENTARIAS_INICIO]: buscaDetalhesOrdensPagamentosExtraorcamentariasInicio,
    [Types.BUSCA_DETALHES_ORDENS_PAGAMENTOS_EXTRAORCAMENTARIAS_ERRO]: buscaDetalhesOrdensPagamentosExtraorcamentariasErro,
    [Types.BUSCA_DETALHES_ORDENS_PAGAMENTOS_EXTRAORCAMENTARIAS_SUCESSO]: buscaDetalhesOrdensPagamentosExtraorcamentariasSucesso,
})
